module.exports = __webpack_public_path__ + "static/img/produto_g.9758f8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/energy-drink/produto_g.png
// module id = KkaM
// module chunks = 0